export const logicaTomarTurno = (
  turnosDisponibles,
  ordenDigitalState,
  turno,
  selectDropDown,
  pacienteAuth,
  type,
  dtoNuevaBusqueda,
  idProtocolo,
  osAlternativa
) => {
  const esParticular =
    turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
      .flgEspecialidadPart;
  const esPorVideollamada =
    turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda.videoConsulta;
  const idTurno = turno.idTurno;
  const familiar = selectDropDown.selectDropDown.selectGlobal.pacienteElegido;
  const ordenDigital = ordenDigitalState.ordenDigital.altaTurno;
  const ordenDigitalMedico = ordenDigitalState.ordenDigital.idMedSolicitante;
  let accion = sessionStorage.getItem("accionHash");
  // const familiarConsultaMedica = selectDropDown.selectDropDown.consulMedica.pacienteElegido;
  // const familiarEstudios = selectDropDown.selectDropDown.estudios.pacienteElegido;
  // const familiarLaboratorio = selectDropDown.selectDropDown.laboratorio.pacienteElegido;
  if (type === "CONSULTA_MEDICA" && familiar) {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      idObraSocial: familiar.paciente.obra_social,
      idPaciente: familiar.paciente.codigo,
      idPlan: familiar.paciente.idplan,
      operador: accion ? "BOT" : "",
      tipoiva: familiar.paciente.tipoiva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      sectorTurno: process.env.SECTOR_TURNO,
      descripcion: turno.medico,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  } else if (type === "CONSULTA_MEDICA") {
    let dtoTomarTurno = {
      idTurno: idTurno,
      idGrupoMedico: 0,
      idObraSocial: pacienteAuth.auth.data.paciente.obra_social,
      idPaciente: pacienteAuth.auth.data.paciente.codigo,
      idPlan: pacienteAuth.auth.data.paciente.idplan,
      operador: accion ? "BOT" : "",
      sectorTurno: process.env.SECTOR_TURNO,
      tipoiva: pacienteAuth.auth.data.paciente.tipoiva,
      particular: esParticular,
      videoConsulta: esPorVideollamada,
      descripcion: turno.medico,
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  }
  if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idplan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen !==
      "CONSULTA_MEDICA"
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth.data.paciente.idplan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth.data.paciente.tipoiva,
      idOrdenDigital: ordenDigital ? ordenDigital : -1,
      idMedSolicitante: ordenDigitalMedico !== null ? ordenDigitalMedico : "",
    };

    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: pacienteAuth.auth.data.paciente.idplan,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: pacienteAuth.auth.data.paciente.tipoiva,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else if (
    type === "ESTUDIOS" &&
    turnosDisponibles.turnosDisponibles.turnosData.volverOrigen ===
      "CONSULTA_MEDICA" &&
    familiar
  ) {
    let dtoTomarTurno = {
      ...dtoNuevaBusqueda,
      idTurno: idTurno,
      idPlan: familiar.paciente.idplan,
      idObraSocial: familiar.paciente.obra_social,
      idPaciente: familiar.paciente.codigo,
      sectorTurno: process.env.SECTOR_TURNO,
      videoAtencion:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .videoAtencion,
      idGrupoMedico:
        turnosDisponibles.turnosDisponibles.turnosData.dtoBusqueda
          .idGrupoMedico,
      GruposMedico: turnosDisponibles.turnosDisponibles.turnosData.GruposMedico,
      tipoiva: familiar.paciente.tipoiva,
    };
    return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
  }
  if (
    idProtocolo !== null &&
    idProtocolo !== undefined &&
    idProtocolo !== "-1" &&
    !familiar
  ) {
    let dtoTomarTurno = {
      id: idTurno,
      IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
      IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
      esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
      IdProtocoloAlta: idProtocolo,
      OsAlternativa: osAlternativa,
    };
    return { dto: dtoTomarTurno, idFamiliar: false };
  } else {
    if (type === "LABORATORIO" && familiar) {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: familiar.paciente.tipoiva,
        IdProtocoloAlta: idProtocolo,
        OsAlternativa: osAlternativa,
      };
      return { dto: dtoTomarTurno, idFamiliar: familiar.paciente.codigo };
    } else if (type === "LABORATORIO") {
      let dtoTomarTurno = {
        id: idTurno,
        IdGrupoEstAlta: dtoNuevaBusqueda.idGrupo,
        IdGrupoEstudio: dtoNuevaBusqueda.idGrupo,
        sectorTurno: process.env.SECTOR_TURNO,
        esParticular: turnosDisponibles.turnosDisponibles.turnosData.particular,
        tipoiva: pacienteAuth.auth.data.paciente.tipoiva,
        OsAlternativa: osAlternativa,
      };
      return { dto: dtoTomarTurno, idFamiliar: false };
    }
  }
};
